/**
 * Tomaruba Guest API
 * Tomaruba Guest API
 *
 * OpenAPI spec version: 1.0.0
 * Contact: development@tomaruba.me
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient'

/**
 * The ReservationPay model module.
 * @module model/ReservationPay
 * @version 1.0.0
 */
export default class ReservationPay {
  /**
   * Constructs a new <code>ReservationPay</code>.
   * @alias module:model/ReservationPay
   * @class
   */

  constructor() {}

  /**
   * Constructs a <code>ReservationPay</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ReservationPay} obj Optional instance to populate.
   * @return {module:model/ReservationPay} The populated <code>ReservationPay</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ReservationPay()

      if (data.hasOwnProperty('id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'Number')
      }
      if (data.hasOwnProperty('reservation_id')) {
        obj['reservation_id'] = ApiClient.convertToType(data['reservation_id'], 'Number')
      }
      if (data.hasOwnProperty('accommodation_fee_paid')) {
        obj['accommodation_fee_paid'] = ApiClient.convertToType(data['accommodation_fee_paid'], 'Boolean')
      }
      if (data.hasOwnProperty('accommodation_tax_paid')) {
        obj['accommodation_tax_paid'] = ApiClient.convertToType(data['accommodation_tax_paid'], 'Boolean')
      }
    }
    return obj
  }

  /**
   * @member {Number} id
   */
  id = undefined
  /**
   * @member {Number} reservation_id
   */
  reservation_id = undefined
  /**
   * @member {Boolean} accommodation_fee_paid
   */
  accommodation_fee_paid = undefined
  /**
   * @member {Boolean} accommodation_tax_paid
   */
  accommodation_tax_paid = undefined
}
